import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
var ForbiddenIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/_jsx(BaseSvg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden,
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.48466 1.84074L10.3032 4.91585C11.1218 5.1002 12.7589 5.46892 12.7146 5.69015C12.6704 5.91138 10.4359 5.97775 10.3032 6.13261C10.2456 6.1998 10.3475 6.68569 10.3032 6.90692C10.6793 7.09865 11.374 7.48212 11.6748 7.48212C12.0509 7.48212 13.7765 6.88479 14.1969 6.90692C14.5331 6.92462 14.4181 8.63252 14.1969 9.56168C13.8798 9.62805 12.9978 9.72097 12.7146 9.56168C12.3607 9.36258 11.0554 8.56615 10.8784 8.96436C10.7368 9.28293 11.844 13.6545 12.4635 15.8004C11.9251 15.9479 10.6528 16.057 9.48466 16.0216C8.31656 15.9862 6.90363 15.9184 6.34318 15.8004C6.89626 13.6987 7.98029 9.42895 7.8918 9.16347C7.78118 8.83162 7.3166 8.63252 6.34318 9.27409C5.56445 9.78734 4.91256 9.91565 4.68395 9.91565C4.54384 9.23721 4.27689 7.80069 4.32998 7.48212L4.19724 7.0839C4.19724 7.21664 4.16185 7.48212 4.02026 7.48212C3.84328 7.48212 3.64417 6.37596 3.66629 6.13261C3.68399 5.93793 3.90964 2.32744 4.19724 2.08409C4.48484 1.84074 4.19724 6.13261 4.19724 6.13261H4.48485C4.45543 6.33172 4.42532 6.76533 4.54027 6.90692C4.5944 6.8033 4.6472 6.71728 4.68395 6.66356C4.85356 6.8553 5.38747 7.23876 6.1662 7.23876C6.94493 7.23876 8.05403 7.13552 8.51124 7.0839C8.47437 6.83317 8.42275 6.13703 8.51124 5.97775C8.26789 5.84501 6.1662 5.71227 6.1662 5.53529C6.1662 5.3937 8.51124 4.91585 8.51124 4.91585L9.48466 1.84074Z M15.0597 3.16812L13.4447 15.8004H14.1969L15.834 3.16812H15.0597Z"
    })
  }));
});
ForbiddenIcon.displayName = 'ForbiddenIcon';
export default ForbiddenIcon;